import styled from 'styled-components'
import { desktopBreakpoint, tabletBreakpoint } from 'react-components'

export const Title = styled.h2`
    margin: ${props => props.theme.spacing.xxLarge} 1.25rem 0;
    text-align: ${props => props.theme.style.textAlign.center};
    font-family: ${props => props.theme.typography.font.family.yummo};
    color: ${props => props.theme.colors.white};
    font-size: 1.75rem;
    font-weight: bold;
    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        font-size: 2.125rem;
        margin: 4.375rem auto 0;
    }
    @media only screen and (min-width: ${desktopBreakpoint.min}px) {
        font-size: 2.125rem;
        margin: ${props => props.theme.layout.medium} auto 0;
    }
`
export const Subtitle = styled.div`
    margin: 1.25rem 1.25rem 1.875rem;
    text-align: ${props => props.theme.style.textAlign.center};
    font-family: ${props => props.theme.typography.font.family.lato};
    font-size: ${props => props.theme.typography.font.size.medium};
    color: ${props => props.theme.colors.white};
    line-height: 1.38;
    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        margin: 1.3125rem auto 1.875rem;
    }
`
export const ContactNumberContainer = styled.div`
    text-align: ${props => props.theme.style.textAlign.center};
    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        margin-right: 1.5625rem;
    }
`
export const ContactNumber = styled.a`
    font-family: ${props => props.theme.typography.font.family.yummo};
    color: ${props => props.theme.colors.white};
    text-decoration: none;
    font-size: 1.75rem;
    &:link, &:visited: {
        text-decoration: none;
        color: ${props => props.theme.colors.white};
    }
    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        font-size: 2.125rem;
    }
`
export const ContactEmailContainer = styled.div`
    margin-top: 0.9375rem;
    text-decoration: none;
    text-align: ${props => props.theme.style.textAlign.center};
    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        display: ${props => props.theme.style.display.flex};
        flex-direction: ${props => props.theme.style.flexDirection.column};
        justify-content: ${props => props.theme.style.justifyContent.center};
        margin-top: 0;
        margin-left: 1.5625rem;
    }
`
export const ContactEmail = styled.a`
    font-family: ${props => props.theme.typography.font.family.lato};
    font-size: ${props => props.theme.typography.font.size.medium};
    color: ${props => props.theme.colors.white};
    &:link, &:visited: {
        color: ${props => props.theme.colors.white};
    }
`
export const ButtonContainer = styled.div`
    margin: 0.9375rem auto ${props => props.theme.spacing.xxLarge};
    text-align: ${props => props.theme.style.textAlign.center};
    font-family: ${props => props.theme.typography.font.family.lato};
    font-size: ${props => props.theme.typography.font.size.medium};
    color: ${props => props.theme.colors.tfwBlack87};
    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        margin: 0.9375rem auto 4.375rem;
    }
    @media only screen and (min-width: ${desktopBreakpoint.min}px) {
        margin: 0.9375rem auto ${props => props.theme.layout.medium};
    }
`

export const CustomerSupportFooterSectionContainer = styled.section`
    background-color: ${props => props.theme.colors.tfwBlue};
    display: ${props => props.theme.style.display.flex};
    flex-direction: ${props => props.theme.style.flexDirection.column};
`

export const ContactContainer = styled.div`
    margin: 0 1.25rem 0.9375rem 1.1875rem;
    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        display: ${props => props.theme.style.display.flex};
        flex-direction: ${props => props.theme.style.flexDirection.row};
        margin: 0 auto 0.9375rem;
    }
`
